// El correo del usuario llega en un claim distinto según el tenant:
//   B2C  -> `emails` (arreglo)
//   CIAM -> `preferred_username`, que es lo que MSAL expone como account.username
// `extension_upn` queda como último recurso: lo agrega nuestro propio API.
//
// Se usa `||` y no `??`: MSAL deja `username` en cadena vacía cuando no hay
// `preferred_username`, y `??` solo cae con null/undefined.
//
// Vive en su propio archivo porque acá hay dos consumidores: `identityManager`, que lo
// guarda en localStorage, y `App`, que se lo pasa a `myApps` para pedir los servicios
// del usuario al Authorization API.
export default function resolveUserName(account) {
    const claims = account?.idTokenClaims ?? {};
    return account?.username
        || claims.preferred_username
        || claims.emails?.[0]
        || claims.email
        || claims.extension_upn
        || "";
}
